<template>
  <q-btn
    v-bind="$attrs"
    icon="fas fa-location-arrow"
    :label="buttonLabel"
    data-test-id="use-current-location-button"
    :disable="!$_.isNil(locationError)"
    @click="getCurrentLocation"
  >
    <q-tooltip v-if="iconOnly">
      {{ locationError || $t('siteLocation.actions.useCurrentLocation') }}
    </q-tooltip>
  </q-btn>
</template>

<script>
export default {
  name: 'UseCurrentLocationButton',
  props: {
    iconOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['current-location-request', 'current-location-response', 'loading'],
  data () {
    return {
      locationError: null
    }
  },
  computed: {
    buttonLabel () {
      if (this.iconOnly) {
        return undefined
      } else if (_.isNil(this.locationError)) {
        return this.label || this.$t('siteLocation.actions.useCurrentLocation')
      } else {
        return this.$t('siteLocation.locationUnavailable')
      }
    }
  },
  methods: {
    getCurrentLocation () {
      this.$emit('current-location-request')
      try {
        // Uncomment for testing without location services
        // this.handleCurrentLocationResult({ coords: { latitude: 37.529959, longitude: -122.276802 } })
        navigator.geolocation.getCurrentPosition(this.handleCurrentLocationResult, this.handleCurrentLocationError)
      } catch (error) {
        this.$mh.showErrors(['Failed to get current location', error])
        this.$emit('current-location-response', null)
      }
    },
    handleCurrentLocationResult (position) {
      const origin = { lat: position.coords.latitude, lon: position.coords.longitude }
      this.$emit('current-location-response', origin)
    },
    handleCurrentLocationError (error) {
      this.locationError = error
      this.$rollbar.info('Failed to get current location', { error })
      this.$emit('current-location-response', null)
    }
  }
}
</script>
